function setOptionalSource(imageElement, path) {
	if(path)
		imageElement.setAttribute('src', path);
}

module.exports = setOptionalSource;